<template>
  <div>
    <!-- comment search in screen booked  -->
    <!-- <b-field grouped group-multiline>
      <div class="control">
        <b-field label="陸社">
          <b-autocomplete
            size="is-small"
            clearable
            :data="transporters"
            field="Company_Alphabet.value"
            v-model="transporterInput"
            @input="
              (v) =>
                (transporterSelection =
                  v.length == 0 ? null : transporterSelection)
            "
            @select="(option) => (transporterSelection = option)"
          >
            <template #empty>No results found</template>
          </b-autocomplete>
        </b-field>
      </div>
      <div class="control">
        <b-field label="引取先">
          <b-input size="is-small" v-model="transportFromInput" />
        </b-field>
      </div>
      <div class="control">
        <b-field label="納車先">
          <b-input size="is-small" v-model="transportToInput" />
        </b-field>
      </div>
      <div class="control">
        <b-field label="受注日">
          <b-datepicker
            size="is-small"
            :mobile-native="false"
            :range="true"
            trap-focus
            v-model="orderDate"
          >
            <div style="display: flex; justify-content: space-between">
              <b-button
                label="Today"
                type="is-primary"
                size="is-small"
                icon-left="calendar-day"
                @click="orderDate = today"
              />
              <b-button
                label="Clear"
                size="is-small"
                icon-left="times-circle"
                outlined
                @click="orderDate = null"
              />
            </div>
          </b-datepicker>
        </b-field>
      </div>
      <div class="control">
        <b-field label="請求書確認日">
          <b-datepicker
            size="is-small"
            :mobile-native="false"
            :range="true"
            trap-focus
            v-model="requestDate"
          >
            <div style="display: flex; justify-content: space-between">
              <b-button
                label="Today"
                type="is-primary"
                size="is-small"
                icon-left="calendar-day"
                @click="
                  () => {
                    (requestDate = today), (isRequestDateEmpty = false);
                  }
                "
              />
              <b-button
                label="Empty"
                type="is-info"
                size="is-small"
                @click="
                  () => {
                    (isRequestDateEmpty = true), (requestDate = null);
                  }
                "
              />
              <b-button
                label="Clear"
                size="is-small"
                icon-left="times-circle"
                outlined
                @click="
                  () => {
                    (requestDate = null), (isRequestDateEmpty = false);
                  }
                "
              />
            </div>
          </b-datepicker>
        </b-field>
      </div>
      <div class="control">
        <b-field label="手配完了日">
          <b-datepicker
            size="is-small"
            :mobile-native="false"
            :range="true"
            trap-focus
            v-model="requestConfirmDate"
          >
            <div style="display: flex; justify-content: space-between">
              <b-button
                label="Today"
                type="is-primary"
                size="is-small"
                icon-left="calendar-day"
                @click="
                  () => {
                    (requestConfirmDate = today),
                      (isRequestConfirmDateEmpty = false);
                  }
                "
              />
              <b-button
                label="Empty"
                type="is-info"
                size="is-small"
                @click="
                  () => {
                    (isRequestConfirmDateEmpty = true),
                      (requestConfirmDate = null);
                  }
                "
              />
              <b-button
                label="Clear"
                size="is-small"
                icon-left="times-circle"
                outlined
                @click="
                  () => {
                    (requestConfirmDate = null),
                      (isRequestConfirmDateEmpty = false);
                  }
                "
              />
            </div>
          </b-datepicker>
        </b-field>
      </div>
      <div class="control">
        <b-field label="住所">
          <b-input size="is-small" v-model="addressByZipcodeAutocompleteInput" />
        </b-field>
      </div>
      <div class="control">
        <b-field label="納車日">
          <b-datepicker
            size="is-small"
            :mobile-native="false"
            :range="true"
            trap-focus
            v-model="deliveryDate"
            :disabled="noDeliveryDate"
          >
            <div style="display: flex; justify-content: space-between">
              <b-button
                label="Today"
                type="is-primary"
                size="is-small"
                icon-left="calendar-day"
                @click="
                  () => {
                    (deliveryDate = today),
                      ((isDeliveryDateEmpty = false), (deliveryDate = null));
                  }
                "
              />
              <b-button
                label="Empty"
                type="is-info"
                size="is-small"
                @click="
                  () => {
                    (isDeliveryDateEmpty = true), (deliveryDate = null);
                  }
                "
              />
              <b-button
                label="Clear"
                size="is-small"
                icon-left="times-circle"
                outlined
                @click="
                  () => {
                    (deliveryDate = null), (isDeliveryDateEmpty = false);
                  }
                "
              />
            </div>
          </b-datepicker>
        </b-field>
      </div>
      <div class="control">
        <b-field label="顧客名">
          <b-input size="is-small" v-model="customerName" />
        </b-field>
      </div>
      <div class="control">
        <b-field label="顧客ID">
          <b-input size="is-small" v-model="customerId" />
        </b-field>
      </div>
      <div class="control">
        <b-field label="通常料金以外の事由">
          <select class="jc-select-option" expanded v-model="regularCharge">
            <option class="selected" value="">-</option>
            <option value="サイズのため">サイズのため</option>
            <option value="不動（フォークリフト使用）">
              不動（フォークリフト使用）
            </option>
            <option value="不動（足回りOK）">不動（足回りOK）</option>
          </select>
        </b-field>
      </div>
      <div class="control">
        <b-field label="出品番号">
          <b-input size="is-small" v-model="lotNo" />
        </b-field>
      </div>
      <div class="control">
        <b-field>
          <b-switch
            size="is-small"
            v-model="noDeliveryDate"
            @input="deliveryDate = null"
            >納車未定</b-switch
          >
        </b-field>
      </div>
      <div class="control">
        <b-field>
          <VueJsonToCsv
            :labels="csvLabels"
            :json-data="csvJsonData"
            :csv-title="csvTitle"
          >
            <b-button class="is-small" icon-left="download" @click="download">
            </b-button>
          </VueJsonToCsv>
        </b-field>
      </div>
      <div class="control">
        <b-field>
          <VueJsonToCsv
            :labels="csvCRMLabels"
            :json-data="csvCRMJsonData"
            :csv-title="csvCRMTitle"
          >
            <b-button
              class="is-small"
              icon-left="download"
              @click="downloadForCRM"
            >
              For NEW CRM
            </b-button>
          </VueJsonToCsv>
        </b-field>
      </div>
    </b-field> -->
    <fieldset class="group-search">
      <legend class="group-search-legend">DB全件検索</legend>
      <b-field grouped group-multiline class="group-search-content">
            <div class="control">
              <b-field label="車台番号">
                <b-input size="is-small" v-model="searchVinNo" />
              </b-field>
            </div>

            <div class="control">
              <b-field label="出品番号">
                <b-input size="is-small" v-model="searchLotNo" />
              </b-field>
            </div>

            <div class="control">
                <b-field label="通常料金以外の事由">
                <select class="jc-select-option" expanded v-model="searchRegularCharge">
                  <option class="selected" value=""></option>
                  <option value="サイズのため">サイズのため</option>
                  <option value="不動（フォークリフト使用）">
                    不動（フォークリフト使用）
                  </option>
                  <option value="不動（足回りOK）">不動（足回りOK）</option>
                </select>
                </b-field>
            </div>

      </b-field>
      <b-field grouped group-multiline class="group-search-content">
        
        <div class="control">
          <b-field label="受注日（始）">
            <b-datepicker
              size="is-small"
              position="is-bottom-right"
              editable
              v-model="orderDateStart"
              @input="setOrderDateStart($event)"
            />
          </b-field>
        </div>
        <div class="control">
          <b-field label="受注日（至）">
            <b-datepicker
              size="is-small"
              position="is-bottom-right"
              editable
              v-model="orderDateEnd"
              @input="setOrderDateEnd($event)"
            />
          </b-field>
        </div>

        <!-- transportRequestDate -->
        <div class="control">
          <b-field label="請求書確認日（始）">
            <b-datepicker
              size="is-small"
              position="is-bottom-right"
              editable
              v-model="requestDateStart"
              @input="setRequestDateStart($event)"
            />
          </b-field>
        </div>
        <div class="control">
          <b-field label="請求書確認日（至）">
            <b-datepicker
              size="is-small"
              position="is-bottom-right"
              editable
              v-model="requestDateEnd"
              @input="setRequestDateEnd($event)"
            />
          </b-field>
        </div>
        
        <!-- transportRequestConfirmDate -->
        <div class="control">
          <b-field label="手配完了日（始）">
            <b-datepicker
              size="is-small"
              position="is-bottom-right"
              editable
              v-model="requestConfirmDateStart"
              @input="setRequestConfirmDateStart($event)"
            />
          </b-field>
        </div>
        <div class="control">
          <b-field label="手配完了日（至）">
            <b-datepicker
              size="is-small"
              position="is-bottom-right"
              editable
              v-model="requestConfirmDateEnd"
              @input="setRequestConfirmDateEnd($event)"
            />
          </b-field>
        </div>

        <!-- transportEstimatedArrivalDate -->
        <div class="control">
          <b-field label="納車日（始）">
            <b-datepicker
              size="is-small"
              position="is-bottom-right"
              editable
              :disabled="checkDeliveryDate"
              v-model="transportEstimatedArrivalDateStart"
              @input="setTransportEstimatedArrivalDateStart($event)"
            />
          </b-field>
        </div>
        <div class="control">
          <b-field label="納車日（至）">
            <b-datepicker
              size="is-small"
              position="is-bottom-right"
              editable
              :disabled="checkDeliveryDate"
              v-model="transportEstimatedArrivalDateEnd"
              @input="setTransportEstimatedArrivalDateEnd($event)"
            />
          </b-field>
        </div>
        
        <!-- 3 thang sau start-task-260
        <div class="control">
        <b-field label="陸送リスト">
          <select class="jc-select-option" expanded v-model="tranRequest">
            <option class="selected" value="">ALL</option>
            <option value="1">「1回目陸送</option>
            <option value="2">「2回目以降陸送」</option>
          </select>
        </b-field>
        </div> -->
      </b-field>
      <b-field grouped group-multiline class="group-search-content">
        <div class="control custom-size">
          <!-- <b-field label="陸社">
            <b-input size="is-small" v-model="searchcompany" />
          </b-field> -->
          <b-field label="陸社" expanded>
          <b-autocomplete
            size="is-small"
            :data="filteredCompany"
            field="Company_Alphabet.value"
            v-model="searchcompany"
            open-on-focus
            clearable
          >
          </b-autocomplete>
        </b-field>
        </div>

        <div class="control custom-size">
        <b-field label="引取先" expanded>
          <!-- <b-input size="is-small" v-model="searchTransportFromName" /> -->
          <b-autocomplete
            size="is-small"
            :data="filteredTransportFromName"
            field="transportFromName"
            v-model="searchTransportFromName"
            open-on-focus
            clearable
          >
          </b-autocomplete>
        </b-field>
        </div>

        <div class="control custom-size" style="width: 26%;">
        <b-field label="納車先" expanded>
          <!-- <b-input size="is-small" v-model="searchTransportToInput" /> -->
          <b-autocomplete
            size="is-small"
            :data="filteredYardName"
            field="AREA_NAME.value"
            v-model="searchTransportToInput"
            open-on-focus
            clearable
          >
          </b-autocomplete>
        </b-field>
        </div>

        <div class="control">
        <b-field label="顧客名">
          <!-- <b-input size="is-small" v-model="searchCustomerName" /> -->
          <b-autocomplete
            size="is-small"
            :data="filteredCustomerName"
            field="customer_name"
            v-model="searchCustomerName"
            open-on-focus
            clearable
          >
          </b-autocomplete>
        </b-field>
        </div>

        <div class="control">
        <b-field label="顧客ID">
          <!-- <b-input size="is-small" v-model="searchCustomerId" /> -->
          <b-autocomplete
            size="is-small"
            :data="filteredCustomerId"
            field="customer_id_format"
            v-model="searchCustomerId"
            open-on-focus
            clearable
          >
          </b-autocomplete>
        </b-field>
        </div>

        <!-- <div class="control">
          <b-field label="住所">
            <b-input size="is-small" v-model="adressByZipcodeInput" />
          </b-field>
        </div> -->
      </b-field>
      <b-field grouped group-multiline class="group-search-content">
        <b-button
            class="btn-search"
            icon-left="search"
            @click="searchDataAllBooked"
          >
            全件検索
        </b-button>

        <b-button
            class="btn-search"
            @click="clearDataAllBooked"
          >
          クリア
        </b-button>

        <div class="control button-icon-switch">
          <b-field>
            <b-switch
              size="is-small"
              v-model="checkDeliveryDate"
              @input = "changeDeliveryDate"
              >納車未定</b-switch
            >
          </b-field>
        </div>

        <div class="control">
          <b-field>
            <VueJsonToCsv
              :labels="csvLabels"
              :json-data="csvJsonData"
              :csv-title="csvTitle"
            >
              <b-button class="is-small" icon-left="download" @click="download">
              </b-button>
            </VueJsonToCsv>
          </b-field>
        </div>

        <div class="control">
          <b-field>
            <VueJsonToCsv
              :labels="csvCRMLabels"
              :json-data="csvCRMJsonData"
              :csv-title="csvCRMTitle"
            >
              <b-button
                class="is-small"
                icon-left="download"
                @click="downloadForCRM"
              >
                For NEW CRM
              </b-button>
            </VueJsonToCsv>
          </b-field>
        </div>
      </b-field>

      
    </fieldset>
    <ActionBar
      :checkedItems="checkedItems"
      @done="actionDone"
      :isBooked="true"
      :isOrders="false"
    />
    <ItemTableList
      ref="list"
      checkable
      @onUpdateCheckedItems="onUpdateCheckedItems"
      @filterListItem="filterListItem"
      :items="filteredItems"
      :isBooked="true"
      @item-click="itemClick"
    />
    <div class="div-load-more"
      style="display: flex; justify-content: center; align-items: center"
    >
      <b-button label="更に表示" type="is-primary" @click="loadMore" v-if="isLoadMore==true" />
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import _debounce from 'lodash/debounce';
import itemRepository from '@/repositories/item';
import jcPackage from '@/repositories/jcPackage';
import { Item } from '@/models';
const DATE_FORMAT = 'YYYY-MM-DD';
const LIMIT_LOAD = 100;
export default {
  data: () => ({
    
    today: [],
    checkedItems: [],
    filteredItems: [],
    transporterOptions: [],
    transporterInput: '',
    transporterSelection: null,
    transportFromInput: '',
    customerId: null,
    customerName: null,
    transportToInput: '',
    orderDate: null,
    requestDate: null,
    isRequestDateEmpty: false,
    requestConfirmDate: null,
    isRequestConfirmDateEmpty: false,
    deliveryDate: null,
    isDeliveryDateEmpty: false,
    noDeliveryDate: false,
    csvLabels: {},
    csvJsonData: [],
    csvTitle: '',
    orderItems: [],
    regularCharge: '',
    csvCRMLabels: {},
    csvCRMJsonData: [],
    csvCRMTitle: '',
    listMatterNo: [],
    listTransportTotalRequest: null,
    orderDateStart: '',
    orderDateEnd: '',
    searchVinNo: '',
    allBookedFilter: [],
    lotNo: null,
    searchcompany: '',
    tranRequest: '',
    addressByZipcodeAutocompleteInput: '',
    adressByZipcodeInput: '',
    isLoadMore: true,
    searchTransportToInput:'',
    searchCustomerName:'',
    searchCustomerId:'',
    searchTransportFromName:'',
    requestDateStart: '',
    requestDateEnd: '',
    requestConfirmDateStart:'',
    requestConfirmDateEnd:'',
    transportEstimatedArrivalDateStart:'',
    transportEstimatedArrivalDateEnd:'',
    searchRegularCharge:'',
    searchLotNo:'',
    checkDeliveryDate:false,
    auctions:[],
    yards:[],
    listCustomerInf:[],
    listTransportFromName:[]
  }),
  components: {
    ItemTableList: () => import('@/components/ItemTableList'),
    ActionBar: () => import('@/components/ActionBar.vue'),
    VueJsonToCsv: () => import('vue-json-to-csv'),
  },
  async created() {
    this.$store.commit('isLoadingApi', true);
    itemRepository.resetGetBookedStartAt();
    this.$store.state.bookedItems = []
    await this.$store.dispatch('fetchBookedItems');
    this.filteredItems = this.$store.getters.bookedItems;
    
    this.$store.commit('isLoadingApi', true);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.today = [today, today];
    this.debounceFilter = _debounce(this.filter, 1000);

    this.transporterOptions = this.$store.state.transportVendors;
    this.auctions = this.$store.state.auctionVendors;
    this.yards = this.$store.state.yardVendors;
    this.listCustomerInf = this.$store.state.listCustomerInf;
    this.auctions.forEach(element => {
      let model = {
        transportFromName : element.AuctionAreaSatellite.value
      }
      this.listTransportFromName.push(model);
    });

    this.yards.forEach(element => {
      let model = {
        transportFromName : element.AREA_NAME.value
      }
      this.listTransportFromName.push(model);
    });
    this.$store.commit('isLoadingApi', false);
    this.$watch(
      () => [
        this.items,
        this.transporterSelection,
        this.orderDate,
        this.requestDate,
        this.isRequestDateEmpty,
        this.requestConfirmDate,
        this.isRequestConfirmDateEmpty,
        this.deliveryDate,
        this.isDeliveryDateEmpty,
        this.noDeliveryDate,
        this.transportFromInput,
        this.transportToInput,
        this.customerName,
        this.customerId,
        this.regularCharge,
        this.lotNo,
        this.transporterInput,
        this.addressByZipcodeAutocompleteInput,
        // this.tranRequest1
      ],
      () => this.debounceFilter()
      
    );

    this.transporterInput = this.$route.query.tr || '';
    this.transportFromInput = this.$route.query.tf || '';
    this.transportToInput = this.$route.query.tt || '';
    this.customerName = this.$route.query.cn || '';
    this.customerId = this.$route.query.ci || '';
    this.lotNo = this.$route.query.ln || '';
    this.orderDate = this.$route.query.od
      ? this.$route.query.od.split('-').map((d) => moment(d).toDate())
      : null;
    this.requestDate = this.$route.query.rd
      ? this.$route.query.rd.split('-').map((d) => moment(d).toDate())
      : null;
    this.requestConfirmDate = this.$route.query.cd
      ? this.$route.query.cd.split('-').map((d) => moment(d).toDate())
      : null;
    this.deliveryDate = this.$route.query.dd
      ? this.$route.query.dd.split('-').map((d) => moment(d).toDate())
      : null;
    this.noDeliveryDate = !!this.$route.query.nd;
    this.addressByZipcodeAutocompleteInput = this.$route.query.ad || '';
    await this.getData();
    this.$store.commit('isLoadingApi', false);
  },
  computed: {
    items() {
      return this.$store.getters.bookedItems;
    },
    transporters() {
      return this.transporterOptions.filter((v) => {
        return (
          v['Company_Alphabet']['value']
            .trim()
            .toLowerCase()
            .indexOf(this.transporterInput.toLowerCase()) >= 0 ||
           v['Company']['value']
            .trim()
            .toLowerCase()
            .indexOf(this.transporterInput.toLowerCase()) >= 0
        );
      });
    },
    filteredCompany() {
      return this.transporterOptions.filter((v) => {
        return (
           v['Company_Alphabet']['value']
            .trim()
            .toLowerCase()
            .indexOf(this.searchcompany.toLowerCase()) >= 0
        );
      });
    },
    filteredTransportFromName() {
      return this.listTransportFromName.filter(
        (option) =>
          option.transportFromName
            .toUpperCase()
            .indexOf(this.searchTransportFromName.toUpperCase()) >= 0
      );
    },
    filteredYardName() {
      return this.yards.filter(
        (option) =>
          option.AREA_NAME.value
            .toUpperCase()
            .indexOf(this.searchTransportToInput.toUpperCase()) >= 0
      );
    },
    filteredCustomerId() {
      return this.listCustomerInf.filter(
        (option) =>
          option.customer_id_format
            .toUpperCase()
            .indexOf(this.searchCustomerId.toUpperCase()) >= 0
      );
    },
    filteredCustomerName() {
      return this.listCustomerInf.filter(
        (option) =>
          option.customer_name
            .toUpperCase()
            .indexOf(this.searchCustomerName.toUpperCase()) >= 0
      );
    },
  },
  methods: {
    getData() {
      this.orderItems = this.$store.getters.incompleteItems;
      this.$store.commit('setOrdersCount', this.orderItems.length);
      if (this.$store.getters.transportVendorsWithItems.length > 0) {
        this.filterDate(
          this.$store.getters.transportVendorsWithItems[0].items,
          this.orderItems
        );
      }
      
      this.items.map((item) => this.listMatterNo.push(item.matterNo));
      const listTransportTotalRequestApi = jcPackage.getListTransportOderByMatterNo(
        this.$store.state.accessTokenJPC,
        this.listMatterNo
      );
      listTransportTotalRequestApi.then((rs) => {
        this.listTransportTotalRequest = rs.data;
      });

    },
    filterDate(data, items) {
      let arrayIndex = [];
      let arrayData = [];
      data.map((x) => {
        this.orderItems.map((y, index) => {
          if (x.vinNo == y.vinNo && x.transportFromId == y.transportFromId) {
            arrayIndex.push(index);
          }
        });
      });
      this.orderItems.map((x, index) => {
        let a = arrayIndex.indexOf(index);
        if (a < 0) {
          arrayData.push(x);
        }
      });
      this.orderItems = [...arrayData];
      this.$store.commit('setOrdersCount', this.orderItems.length);
    },
    download() {
      this.csvLabels = {
        orderDate: { title: '受注' },
        vinNo: { title: '車台番号' },
        model: { title: '車種' },
        hasNumberPlate: { title: 'ナンバー' },
        transportOptionNumberPlateCut: { title: 'カット' },
        conditionChecked: { title: '状態チェック' },
        remarks: { title: '備考' }, // conditionRemark
        transportFrom: { title: '引取先' },
        transportFromEn: { title: '引取先（en）' },
        transportTo: { title: '納車先' },
        transportToEn: { title: '納車先（en）' },
        transportVendorName: { title: '陸送会社' },
        transportActualCost: { title: '陸送費' },
        transportOutFee: { title: '搬出費' },
        transportNumberPlateCutFee: { title: 'カット料' },
        transportTotalActualCost: { title: '費用合計' },
        transportCost: { title: '陸送請求額' },
        regularCharge: { title: '通常料金以外の事由' },
        transportTotalCost: { title: '請求合計' },
        transportRequestDate: { title: '手配' },
        transportRequestConfirmDate: { title: '手配完了' },
        transportEstimatedArrivalDate: { title: '納車予定' },
        customerName: { title: '顧客名' },
        customerId: { title: '顧客ID' },
        yardConfirmationDate: { title: 'ヤード確定日' },
        yardConfirmed: { title: 'ヤード確定者' },
        landTransportationArrangementDate: { title: '陸送手配日' },
        landTransportationArranger: { title: '陸送手配者' },
        lotNo: { title: '出品番号' },
        handlingCompanyJp: { title: '取扱い(JP)' },
        handlingCompanyEn: { title: '取扱い(EN)' },
        id: { title: 'ID' },
        matterNo: { title: 'matterNo' },
        transportToArea: { title: 'エリア' },
        status: { title: 'ステータス' },
        invoiceIsuueDate : { title: '請求書作成日'}
      };
      this.csvJsonData = this.filteredItems.map((item) =>
        Object.assign({}, item, {
          remarks: item.getRemarks(),
          transportFrom: ((item.isOpenSearchAddressByZipCodePopupFlag == true && (item.suppliersName || item.addressByZipcode)) ? 
            (item.suppliersName ? ( item.suppliersName +  (item.addressByZipcode ? ' - ' + item.addressByZipcode : '' )) : item.addressByZipcode) : 
            item.transportFromName),
          customerId: item.customerId,
          customerName: item.customerName,
          transportFromEn: item.transportFromId,
          // transportTo: this.transportTo(item),
          transportTo: item.transportToName,
          // transportToEn: this.transportTo(item, 'en'),
          transportToEn: item.transportToId,
          lotNo: item.lotNo,
        })
      );
      this.csvTitle = 'rikuso';
    },
    transportFromEn(id) {
      if (!id) return '';
      const from = this.$store.getters.auctionVendor(id);
      return from ? from.E_AuctionAreaSatellite.value : '';
    },
    transportTo(item, lang) {
      const to = this.$store.getters.yardVendor(item.transportToId);
      switch (lang) {
        case 'en':
          return to ? to.yard_display_full_en.value : '';
        default:
          return to ? to.yard_display_full_jp.value : item.transportToName;
      }
    },
    transportToForCRM(item, lang) {
      const to = this.$store.getters.yardVendor(item.transportToId);
      switch (lang) {
        case 'en':
          return to ? to.NAME.value : '';
        default:
          return to
            ? to.Company.value + ' ' + item.transportToName
            : item.transportToName;
      }
    },
    findTransporters(name) {
     
      return this.transporterOptions.filter((v) => {
        return (
          v['Company_Alphabet']['value'].trim().toLowerCase() == name.trim().toLowerCase()
        );
      });
    },
    onUpdateCheckedItems(props) {
      this.checkedItems = props.items;
    },
    actionDone() {
      this.$refs.list.$data.checkedItems = this.checkedItems = [];
    },
    filterByTransporter(item) {
      if (this.transporterInput.trim() == '') {
        return true
      }
      const transporters = this.findTransporters(this.transporterInput);
      this.transporterSelection = transporters.length > 0 ? transporters[0] : null;
      if (this.transporterSelection) {
        return (
          this.transporterSelection.TransporterID.value == item.transportVendorId
        );
      }
      return true;
    },
    filterByTransportFrom(item) {
      if (item.transportFromName.trim() == '' && this.transportFromInput.trim() == '') return true;
      return (
        item.transportFromName
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.transportFromInput.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterCustomerName(item) {
      if (item.customerName.trim() == '' && this.customerName.trim() == '') return true;
      return (
        item.customerName
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.customerName.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterCustomerId(item) {
      if (item.customerId.trim() == '' && this.customerId.trim() == '') return true;
      return (
        item.customerId
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(this.customerId.trim().toLowerCase().replaceAll(' ', '')) >=
        0
      );
    },
    filterByTransportTo(item) {
      if (item.transportToName.trim() == '' && this.transportToInput.trim() == '') return true;
      let name = item.transportToName;
      if (item.transportToId) {
        const yard = this.$store.getters.yardVendor(item.transportToId);
        name = yard ? `${yard.Company.value}${name}` : name;
      }
      return (
        name
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.transportToInput.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterByOrderDate(item) {
      if (this.orderDate) {
        const d = moment(item.orderDate);
        return this.orderDate[0] <= d && this.orderDate[1] >= d;
      }
      return true;
    },
    filterByRequestDate(item) {
      if (this.requestDate) {
        const d = moment(item.transportRequestDate);
        return this.requestDate[0] <= d && this.requestDate[1] >= d;
      }
      return true;
    },
    filterByRequestDateEmpty(item) {
      if (this.isRequestDateEmpty) {
        this.requestDate = null;
        return item.transportRequestDate == '';
      }
      return true;
    },
    filterByRequestConfirmDate(item) {
      if (this.requestConfirmDate) {
        const d = moment(item.transportRequestConfirmDate);
        return (
          this.requestConfirmDate[0] <= d && this.requestConfirmDate[1] >= d
        );
      }
      return true;
    },
    filterByRequestConfirmDateEmpty(item) {
      if (this.isRequestConfirmDateEmpty) {
        return item.transportRequestConfirmDate == '';
      }
      return true;
    },
    filterByDeliveryDate(item) {
      if (this.deliveryDate) {
        const d = moment(item.transportEstimatedArrivalDate);
        return this.deliveryDate[0] <= d && this.deliveryDate[1] >= d;
      }
      return true;
    },
    filterByDeliveryDateEmpty(item) {
      if (this.isDeliveryDateEmpty) {
        return item.transportEstimatedArrivalDate == '';
      }
      return true;
    },
    filterByNoDeliveryDate(item) {
      if (this.noDeliveryDate) {
        return item.transportEstimatedArrivalDate == '';
      }
      return true;
    },
    filterByRegularChange(item) {
      if (item.regularCharge.trim() == '' && this.searchRegularCharge.trim() == '') return true;
      return (
        item.regularCharge
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.searchRegularCharge.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterLotNo(item) {
      if (item.lotNo.trim() == '' && this.lotNo.trim() == '') return true;
      return (
        item.lotNo
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(this.lotNo.trim().toLowerCase().replaceAll(' ', '')) >= 0
      );
    },
    filterChangeRequest(item) {
      if (this.tranRequest == '') {
        return (
          item.tranRequest == 1 ||
          item.tranRequest == 2 ||
          item.tranRequest == 3 ||
          item.tranRequest == 4 ||
          item.tranRequest == 5 ||
          item.tranRequest == 6
        );
      }
      if (this.tranRequest == '1') {
        return item.tranRequest == 1;
      }
      if (this.tranRequest == '2') {
        return (
          item.tranRequest == 7 ||
          item.tranRequest == 2 ||
          item.tranRequest == 3 ||
          item.tranRequest == 4 ||
          item.tranRequest == 5 ||
          item.tranRequest == 6
        );
      }
    },
    filter() {
      const q = Object.entries({
        tr: this.transporterInput,
        tf: this.transportFromInput,
        tt: this.transportToInput,
        cn: this.customerName,
        ci: this.customerId,
        ln: this.lotNo,
        od:
          this.orderDate &&
          this.orderDate.map((d) => moment(d).format('YYYYMMDD')).join('-'),
        rd:
          this.requestDate &&
          this.requestDate.map((d) => moment(d).format('YYYYMMDD')).join('-'),
        cd:
          this.requestConfirmDate &&
          this.requestConfirmDate
            .map((d) => moment(d).format('YYYYMMDD'))
            .join('-'),
        dd:
          this.deliveryDate &&
          this.deliveryDate.map((d) => moment(d).format('YYYYMMDD')).join('-'),
        nd: this.noDeliveryDate,
        ad: this.addressByZipcodeAutocompleteInput,
      })
        .map((e) => `${e[0]}=${e[1] || ''}`)
        .join('&');
      window.history.replaceState({}, '', `/booked?${q}`);
      
      this.filteredItems = this.items.filter(
        (item) =>
          this.filterByTransporter(item) &&
          this.filterByTransportFrom(item) &&
          this.filterByTransportTo(item) &&
          this.filterByOrderDate(item) &&
          this.filterByRequestDate(item) &&
          this.filterByRequestConfirmDate(item) &&
          this.filterByDeliveryDate(item) &&
          this.filterByNoDeliveryDate(item) &&
          this.filterCustomerId(item) &&
          this.filterCustomerName(item) &&
          this.filterLotNo(item) &&
          this.filterByRequestDateEmpty(item) &&
          this.filterByRequestConfirmDateEmpty(item) &&
          this.filterByDeliveryDateEmpty(item) &&
          this.filterByRegularChange(item) &&
          this.autocompleteFilterByAddressZipcode(item)
      );
      this.transporterOptions = this.$store.state.transportVendors;
    },
    itemClick(p) {
      this.$store.commit('setItemsInList', p.items);
      this.$router.push({
        name: 'item',
        params: {
          id: p.item.id,
          isBookedItem: true,
          isOrder: false,
        },
      });
    },
    async loadMore() {
      this.$store.commit('isLoadingApi', true);
      await this.$store.dispatch('fetchBookedItemsMore');
      this.filteredItems = this.$store.getters.bookedItems;
      this.$store.commit('isLoadingApi', false);
    },
    downloadForCRM() {
      this.csvCRMJsonData = [];
      this.csvCRMLabels = {
        orderDate: { title: '受注' },
        lotNo: { title: '出品番号' },
        transportFromEn: { title: '引取先（en）' },
        transportToEn: { title: '納車先（en）' },
        transportTotalCost: { title: '請求合計' },
        transportEstimatedArrivalDate: { title: '納車予定' },
      };
      this.csvCRMJsonData.push({
        orderDate: 'Auction Date',
        lotNo: 'Auction#',
        transportFromEn: 'Auction',
        transportToEn: 'Delivery Yard',
        transportTotalCost: 'Cost',
        transportEstimatedArrivalDate: 'Yard in Date',
      });
      let totalRequestTransport = 0;
      this.filteredItems.map((item) => {
        if (item.matterNo != '') {
          this.listTransportTotalRequest.find((v) => {
            if (JSON.parse(v).matterNo == item.matterNo) {
              totalRequestTransport = JSON.parse(v).totalRequest;
            }
          });
          if (totalRequestTransport < 2) {
            this.csvCRMJsonData.push({
              orderDate: item.orderDate,
              lotNo: item.lotNo,
              transportFromEn:((item.isOpenSearchAddressByZipCodePopupFlag == true && (item.suppliersName || item.addressByZipcode)) ? 
                (item.suppliersName ? ( item.suppliersName +  (item.addressByZipcode ? ' - ' + item.addressByZipcode : '' )) : item.addressByZipcode) : 
                item.transportFromId),
              transportToEn: item.transportToId,
              transportTotalCost: item.transportTotalCost,
              transportEstimatedArrivalDate: item.transportEstimatedArrivalDate,
            });
          }
        } else {
          this.csvCRMJsonData.push({
            orderDate: item.orderDate,
            lotNo: item.lotNo,
            transportFromEn: ((item.isOpenSearchAddressByZipCodePopupFlag == true && (item.suppliersName || item.addressByZipcode)) ? 
                (item.suppliersName ? ( item.suppliersName +  (item.addressByZipcode ? ' & ' + item.addressByZipcode : '' )) : item.addressByZipcode) : 
                item.transportFromId),
            transportToEn: item.transportToId,
            transportTotalCost: item.transportTotalCost,
            transportEstimatedArrivalDate: item.transportEstimatedArrivalDate,
          });
        }
      });
      this.csvCRMTitle = 'rikusoForCRM';
    },
    async searchDataAllBooked() {
      this.$store.commit('isLoadingApi', true);
      let filterTemp = []
      if ((this.orderDateStart == '')
        && (this.orderDateEnd == '')
        && (this.searchVinNo == '')
        && (this.searchcompany == '')
        && (this.adressByZipcodeInput == '')
        && (this.searchTransportToInput == '')
        && (this.searchCustomerName == '')
        && (this.searchCustomerId == '')
        && (this.searchTransportFromName == '')
        && (this.requestDateStart == '')
        && (this.requestDateEnd == '')
        && (this.requestConfirmDateStart == '')
        && (this.requestConfirmDateEnd == '')
        && (this.transportEstimatedArrivalDateStart == '')
        && (this.transportEstimatedArrivalDateEnd == '')
        && (this.searchRegularCharge == '')
        && (this.searchLotNo == '')
        && (!this.checkDeliveryDate)
      ) {
        filterTemp = this.$store.getters.bookedItems
        this.isLoadMore = true
      } else {
        let transportVendorName = [];
        if (this.searchcompany) {
           transportVendorName = this.transporterOptions.filter((v) => v['Company_Alphabet']['value']== this.searchcompany);
        }
        let transportFromName = [];
        if (this.searchTransportFromName) {
          transportFromName = this.yards.filter((v) => v['AREA_NAME']['value']== this.searchTransportFromName);
        }
        let filterParams = {
          orderDateStart: moment(this.orderDateStart.trim()).format(DATE_FORMAT),
          orderDateEnd: moment(this.orderDateEnd.trim()).format(DATE_FORMAT),
          vinNo: this.searchVinNo.trim(),
          transportVendorName: transportVendorName.length > 0 ? transportVendorName[0].Company.value : this.searchcompany,
          addressByZipcode: this.adressByZipcodeInput.trim(),
          transportToName: this.searchTransportToInput.trim(),
          customerName: this.searchCustomerName.trim(),
          customerId: this.searchCustomerId.trim(),
          transportFromName: transportFromName.length > 0 ? transportFromName[0].YardName.value : this.searchTransportFromName.trim(),
          requestDateStart: moment(this.requestDateStart.trim()).format(DATE_FORMAT),
          requestDateEnd: moment(this.requestDateEnd.trim()).format(DATE_FORMAT),
          requestConfirmDateStart: moment(this.requestConfirmDateStart.trim()).format(DATE_FORMAT),
          requestConfirmDateEnd: moment(this.requestConfirmDateEnd.trim()).format(DATE_FORMAT),
          transportEstimatedArrivalDateStart: moment(this.transportEstimatedArrivalDateStart.trim()).format(DATE_FORMAT),
          transportEstimatedArrivalDateEnd: moment(this.transportEstimatedArrivalDateEnd.trim()).format(DATE_FORMAT),
          regularCharge: this.searchRegularCharge.trim(),
          lotNo: this.searchLotNo.trim(),
          checkDeliveryDate : this.checkDeliveryDate
        }
        filterTemp = await itemRepository.filterBooked(filterParams)
        filterTemp = filterTemp.data.map((item) => new Item(item));
        this.isLoadMore = false
      }
      this.$store.state.bookedItemsSearch = this.filteredItems = filterTemp.filter(
        (item) =>
          this.filterByOrderDateStart(item) &&
          this.filterByOrderDateEnd(item) &&
          this.filterByVinNo(item) &&
          this.filterByCompany(item) &&
          this.filterByAddressZipcode(item) &&
          this.filterTransportToName(item) &&
          this.filterCustomerName(item) && 
          this.filterCustomerId(item) && 
          this.filterByRequestDateStart(item) &&
          this.filterByRequestDateEnd(item) &&
          this.filterByRequestConfirmDateStart(item) &&
          this.filterByRequestConfirmDateEnd(item) && 
          this.filterByDeliveryDateStart(item) &&
          this.filterByDeliveryDateEnd(item) &&
          this.filterByLotNo(item) &&
          this.filterTransportFromName(item) &&
          this.filterByRegularChange(item)
      );
      this.clearChecked();
      this.$store.commit('isLoadingApi', false);
    },
    setOrderDateStart(value) {
      this.orderDateStart = value ? moment(value).format(DATE_FORMAT) : '';
    },
    setOrderDateEnd(value) {
      this.orderDateEnd = value ? moment(value).format(DATE_FORMAT) : '';
    },
    setRequestDateStart(value) {
      this.requestDateStart = value ? moment(value).format(DATE_FORMAT) : '';
    },
    setRequestDateEnd(value) {
      this.requestDateEnd = value ? moment(value).format(DATE_FORMAT) : '';
    },
    setRequestConfirmDateStart(value) {
      this.requestConfirmDateStart = value ? moment(value).format(DATE_FORMAT) : '';
    },
    setRequestConfirmDateEnd(value) {
      this.requestConfirmDateEnd = value ? moment(value).format(DATE_FORMAT) : '';
    },
    setTransportEstimatedArrivalDateStart(value) {
      this.transportEstimatedArrivalDateStart = value ? moment(value).format(DATE_FORMAT) : '';
    },
    setTransportEstimatedArrivalDateEnd(value) {
      this.transportEstimatedArrivalDateEnd = value ? moment(value).format(DATE_FORMAT) : '';
    },
    filterByOrderDateStart(item) {
      if (this.orderDateStart) {
        const d = moment(item.orderDate).format(DATE_FORMAT);
        return d >= this.orderDateStart;
      }
      return true;
    },
    filterByOrderDateEnd(item) {
      if (this.orderDateEnd) {
        const d = moment(item.orderDate).format(DATE_FORMAT);
        return d <= this.orderDateEnd;
      }
      return true;
    },
    filterByVinNo(item) {
      if (item.vinNo.trim() == '' && this.searchVinNo.trim() == '') return true;
      return (
        item.vinNo
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(this.searchVinNo.trim().toLowerCase().replaceAll(' ', '')) >= 0
      );
    },
    filterByCompany(item) {
      if (item.transportVendorName.trim() == '' && this.searchcompany.trim() == '') return true;
      let transportVendorNameTemp =[];
      if (this.searchcompany) {
        transportVendorNameTemp = this.transporterOptions.filter((v) => v['Company_Alphabet']['value'] == this.searchcompany);
        if (transportVendorNameTemp.length > 0) {
          return (
          item.transportVendorName
            .trim()
            .toLowerCase()
            .replaceAll(' ', '')
            .indexOf(
              transportVendorNameTemp[0].Company.value.trim().toLowerCase().replaceAll(' ', '')
            ) >= 0
          );
        } else {
          return false;
        }
      }
      return true;
    },
    filterListItem(data) {
      if (!data.faxFlg && !data.deliveryFlg) {
        this.filter();
      } else {
        this.filteredItems = this.items.filter(
          (item) =>
            this.filterByConfirmFaxReply(item, data.faxFlg) &&
            this.filterByConfirmOfDelivery(item, data.deliveryFlg)
        );
      }
    },
    filterByConfirmFaxReply(item, flag) {
      if (!flag) {
        return true;
      }
      return item.confirmFaxReply == flag;
    },
    filterByConfirmOfDelivery(item, flag) {
      if (!flag) {
        return true;
      }
      return item.confirmOfDelivery == flag;
    },
    autocompleteFilterByAddressZipcode(item) {
      if (item.addressByZipcode.trim() == '' && this.addressByZipcodeAutocompleteInput.trim() == '') return true;
      return (
        item.addressByZipcode
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.addressByZipcodeAutocompleteInput.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterByAddressZipcode(item) {
      if (item.addressByZipcode.trim() == '' && this.adressByZipcodeInput.trim() == '') return true;
      return (
        item.addressByZipcode
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.adressByZipcodeInput.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterTransportToName(item) {
      if (item.transportToId.trim() == '' && this.searchTransportToInput.trim() == '') return true;
      return (
        item.transportToId
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.searchTransportToInput.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterTransportFromName(item) {
      if (item.transportFromName.trim() == '' && this.searchTransportFromName.trim() == '') return true;
      let transportFromName = [];
      if (this.searchTransportFromName) {
          transportFromName = this.yards.filter((v) => v['AREA_NAME']['value']== this.searchTransportFromName);
          if (transportFromName.length > 0) {
            return item.transportFromName
              .trim()
              .toLowerCase()
              .replaceAll(' ', '')
              .indexOf(
                transportFromName[0].YardName.value.trim().toLowerCase().replaceAll(' ', '')
            ) >= 0
          } else {
              return (
                item.transportFromName
                  .trim()
                  .toLowerCase()
                  .replaceAll(' ', '')
                  .indexOf(
                    this.searchTransportFromName.trim().toLowerCase().replaceAll(' ', '')
                  ) >= 0
              );
          }
      }
      return true;
    },
    filterCustomerName(item) {
      if (item.customerName.trim() == '' && this.searchCustomerName.trim() == '') return true;
      return (
        item.customerName
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.searchCustomerName.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterCustomerId(item) {
      if (item.customerId.trim() == '' && this.searchCustomerId.trim() == '') return true;
      return (
        item.customerId
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.searchCustomerId.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterByLotNo(item) {
      if (item.lotNo.trim() == '' && this.searchLotNo.trim() == '') return true;
      return (
        item.lotNo
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(this.searchLotNo.trim().toLowerCase().replaceAll(' ', '')) >= 0
      );
    },
    filterByRequestDateStart(item) {
      if (this.requestDateStart) {
        const d = moment(item.transportRequestDate).format(DATE_FORMAT);
        if(d == 'Invalid date') return false;
        return d >= this.requestDateStart;
      }
      return true;
    },
    filterByRequestDateEnd(item) {
      if (this.requestDateEnd) {
        const d = moment(item.transportRequestDate).format(DATE_FORMAT);
        if(d == 'Invalid date') return false;
        return d <= this.requestDateEnd;
      }
      return true;
    },
    filterByRequestConfirmDateStart(item) {
      if (this.requestConfirmDateStart) {
        const d = moment(item.transportRequestConfirmDate).format(DATE_FORMAT);
        if(d == 'Invalid date') return false;
        return d >= this.requestConfirmDateStart;
      }
      return true;
    },
    filterByRequestConfirmDateEnd(item) {
      if (this.requestConfirmDateEnd) {
        const d = moment(item.transportRequestConfirmDate).format(DATE_FORMAT);
        if(d == 'Invalid date') return false;
        return d <= this.requestConfirmDateEnd;
      }
      return true;
    },
    filterByDeliveryDateStart(item) {
      if (this.checkDeliveryDate) {
        return item.transportEstimatedArrivalDate == '';
      }
      if (this.transportEstimatedArrivalDateStart) {
        const d = moment(item.transportEstimatedArrivalDate).format(DATE_FORMAT);
        if(d == 'Invalid date') return false;
        return d >= this.transportEstimatedArrivalDateStart;
      }
      return true;
    },
    filterByDeliveryDateEnd(item) {
      if (this.checkDeliveryDate) {
        return item.transportEstimatedArrivalDate == '';
      }
      if (this.transportEstimatedArrivalDateEnd) {
        const d = moment(item.transportEstimatedArrivalDate).format(DATE_FORMAT);
        if(d == 'Invalid date') return false;
        return d <= this.transportEstimatedArrivalDateEnd;
      }
      return true;
    },
    changeDeliveryDate(){
      if (this.checkDeliveryDate){
        this.transportEstimatedArrivalDateStart = '';
        this.transportEstimatedArrivalDateEnd = '';
        this.searchDataAllBooked();
      }else{
        this.searchDataAllBooked();
      }
    },
    // filterByBlankDeliveryDate(item) {
    //   if (this.checkDeliveryDate) {
    //     return item.transportEstimatedArrivalDate == '';
    //   }
    //   return true;
    // },
    clearDataAllBooked () {
      this.orderDateStart = '';
      this.orderDateEnd = '';
      this.searchVinNo = '';
      this.searchcompany = '';
      this.adressByZipcodeInput = '';
      this.searchTransportToInput = '';
      this.searchCustomerName = '';
      this.searchCustomerId = '';
      this.searchTransportFromName = '';
      this.requestDateStart = '';
      this.requestDateEnd = '';
      this.requestConfirmDateStart = '';
      this.requestConfirmDateEnd = '';
      this.transportEstimatedArrivalDateStart = '';
      this.transportEstimatedArrivalDateEnd = '';
      this.searchRegularCharge = '';
      this.searchLotNo = '';
      this.checkDeliveryDate = false;
      this.isLoadMore = true;
      this.filteredItems = this.$store.getters.bookedItems;
      this.clearChecked();
    },
    clearChecked(){
      this.$refs.list.clearCheckedItems();
    }
  }
};
</script>
<style>
.display-none {
  display: none;
}
.jc-select-option {
  max-width: 100%;
  width: 100%;
  min-height: 30px;
  cursor: pointer;
  display: block;
  outline: 0;
  background-color: #fff;
  border-color: #dbdbdb;
  border-radius: 2px;
  color: #363636;
}
.selected {
  text-align: center;
}
.group-search {
  width: 100% !important;
  border: 1px solid #a2a3a2;
  margin-bottom: 1.5rem;
}
.group-search-legend {
  margin-left: 10px !important;
  color: #000;
  font-weight: bold;
  font-size: 14px;
}
.group-search-content {
  margin: 10px 0px 15px 25px;
}
.btn-search {
  margin-right: 20px;
  width: 108px !important;
  height: 30px !important;
  font-size: 15px !important;
}

.div-load-more button{
  margin-top: 10px;
}
.button-icon-switch{
  display: flex;
  align-items: center;
  margin-bottom: 10px !important;
}
.custom-size{
  width: 15%;
}

</style>
